import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'
import {isRoomlessRoom} from '@vio/core/src/room/business/utils/roomless'

import type {Room} from '@vio/core/src/room/types/room'

/**
 * How the room title and `RoomInfo` look on the B side of the rooms list
 * improvements. `isEnabled` is false on A, where both stay as they were.
 * A roomless room keeps the A `RoomInfo`. The multiplier and "All rooms have:"
 * only show for a multi-room search and never for a roomless room.
 * @param room - Room the title belongs to.
 * @param searchedRooms - Rooms in the search, from the optimized rooms config.
 */
export const useRoomTitleConfig = (
  room: Pick<Room, 'name'> | undefined,
  searchedRooms: number
) => {
  const toggle = useToggle()
  const isEnabled = toggle('fb6c24d6-ap-rooms-list-improvements', false, true)
  const isRoomInfoEnabled = isEnabled && !isRoomlessRoom(room)
  const isMultiRoom = isRoomInfoEnabled && searchedRooms > 1

  return {
    isEnabled,
    isRoomInfoEnabled,
    numberOfRooms: isMultiRoom ? searchedRooms : 1,
    hasAllRoomsHaveLabel: isMultiRoom
  }
}
